import React from "react"
import classNames from "classnames"

import styles from "./alignIcon.less"

export default (props) => {
  const transformedProps = {
    ["data-info-link-id"]: props.dataInfoLinkId,
  }

  let style = props.style || {}

  return (
    <div
      className={classNames(styles.facadeL, props.facadeClassName)}
      style={{
        ...style,
        width: props.width,
        height: props.height,
        verticalAlign: props.verticalAlign,
        marginRight: props.marginRight,
      }}
      {...transformedProps}>
      <div className={styles.contentL} style={{ top: props.top, left: props.left }}>
        {props.children}
      </div>
    </div>
  )
}
